// @flow
import UpdateProposalChangeMutation from 'mutations/UpdateProposalChangeMutation'
import DeleteProposalChangeMutation from 'mutations/DeleteProposalChangeMutation'
import type {ID} from '../../types'

interface IMutator {
  updateChange: Object => Promise<Object>;
  deleteChange: () => Promise<Object>;
}

class Mutator implements IMutator {
  changeId: ID
  meetingId: ?ID

  constructor(changeId: ID, meetingId: ?ID) {
    this.changeId = changeId
    this.meetingId = meetingId
  }

  updateChange: ((any) => Promise<any>) = (payload: Object): Promise<Object> => UpdateProposalChangeMutation(
    this.changeId,
    this.meetingId,
    payload,
  )

  deleteChange: (() => Promise<any>) = (): Promise<Object> => DeleteProposalChangeMutation({
    changeId: this.changeId,
    meetingId: this.meetingId,
  })
}

/* eslint class-methods-use-this: 0 */
class NullMutator implements IMutator {
  updateChange: ((any) => Promise<any>) = () => Promise.resolve()

  deleteChange: (() => Promise<any>) = () => Promise.resolve()
}

export {NullMutator}

export type {IMutator}

export default Mutator
